import { useAbsoluteLocation } from "@alextheman/components/routing";

const useLocation = useAbsoluteLocation;

export default useLocation;
